import config from "../../../config/domain";
import GlobalStore from "../../store/globalStore";
import { apiService } from "../apiServices";
import servicesList from "../serviceList";

export const AGetStageCompletionStatus = (
  callback: CallableFunction,
  applicationid: string
) => {
  const clientPartialDetails_ao = JSON.parse(
    window.sessionStorage.getItem("clientPartialDetails_ao") || "{}"
  );
  const originalBody = {
    ApplicationId: applicationid,
    esigndocumenttype: 0,
    pan:
      GlobalStore.personaldetails.pan ||
      clientPartialDetails_ao?.pan ||
      ""
  };
  const jsonString = JSON.stringify(originalBody);
  const encryptedBody = btoa(unescape(encodeURIComponent(jsonString)));

  apiService(
    {
      url: "StageDetail/GetStatusV1",
      body: {
        request: encryptedBody,
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getStageCompletionStatus,
    },
    callback
  );
};


export const AUpdateStageCompletionStatus = (
  callback: CallableFunction,
  reaObj?: any
) => {
  apiService(
    {
      url: "StageDetail/Update",
      body: {
        applicationId: reaObj?.applicationId,
        accountCagtegory: reaObj?.accountCagtegory,
        stageOrderId: reaObj?.stageOrderId,
        UserId: reaObj?.UserId ? reaObj?.UserId : "0",
        rmassisted: reaObj?.rmassisted ? reaObj?.rmassisted : false
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getStageCompletionStatus,
    },
    callback
  );

  // apiService(
  //     {
  //         url: 'eco/get-stage-completion-status',
  //         body: {
  //             "applicationid": applicationid
  //         },
  //         method: "POST",
  //     },
  //     callback
  // );
};
export const AGetCacheData = (
  callback: CallableFunction,
  dataObj: {
    uniqueID: string;
    key: string;
  }
) => {
  apiService(
    {
      url: "Cache/Get",
      body: dataObj,
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getCacheData,
    },
    callback
  );
};
